import { io } from "socket.io-client";

// consolacion
// const SOCKET_URL = "wss://ws.myt-conso.com";

// mactan
const SOCKET_URL = "wss://ws.myt-mactan.com";

const socket = io(SOCKET_URL, {
  transports: ["websocket", "polling"],
  reconnectionAttempts: 10,
  timeout: 10000,
  withCredentials: false,
});

socket.on("message", () => {
  console.log(" Connected to WebSocket:", socket.id);
});

socket.on("disconnect", (reason) => {
  console.log(" Disconnected:", reason);
});

socket.on("connect_error", (err) => {
  console.error(" Connect error:", err.message);
});

socket.io.on("reconnect_attempt", (attempt) => {
  console.log(" Reconnect attempt #", attempt);
});

socket.io.on("reconnect_failed", () => {
  console.error(" Reconnect failed after max attempts");
});

export default socket;
